<template>
  <div v-show="popupShow" class="share">
     <custom-modal @closeModal="close" style="z-index: 1999; background: rgba(0, 0, 0, 0.8);"></custom-modal>
     <div class="content-wrapper">
       <img src="@/assets/img/share-img.svg"/>
     </div>
    </div>
</template>
<script>
import customModal from './customModal.vue'
export default {
  components: {
    customModal
  },
  data () {
    return {
      popupShow: true
    }
  },
  mounted () {
    this.open()
  },
  watch: {
    // popupShow (val) {
    //   // 当弹窗隐藏时，需要把分享的事件置空，防止离开弹窗还可以分享
    //   if (val === false) {
    //     wx.onMenuShareAppMessage({})
    //     // wx.onMenuShareTimeline({})
    //   }
    // }
  },
  methods: {
    open () {
      this.popupShow = true
    },
    // 点击遮罩层关闭弹窗
    close () {
      this.popupShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.share {
  position: fixed;
  z-index: 1999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // width: 100%;
  // height: 100%;
  background-color: transparent;

  .content-wrapper {
    position: relative;
    z-index: 2000;
    width: 100vw;
    // height: 100%;
    img {
      margin-top: torem(23px);
      margin-left: torem(66px);
    }
  }
}

</style>
